<!-- eslint-disable operator-linebreak -->
<template>
  <el-dialog
    :visible.sync="show"
    top="7vh"
    width="800px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
  >
    <div class="main-container">
      <div class="header-container">
        <div class="header-tip">{{ lanpack.webTitle }}</div>
        <div class="dialog-close" @click="handleClose">X</div>
      </div>
      <div class="body-container">
        <div class="left-content">
          <el-tabs v-model="currentTab" class="title-content" @tab-click="selectTab">
            <el-tab-pane :label="lanpack.websiteSpeedTest" name="network">
              <div class="result-container">
                <el-row class="result-title">
                  <el-col class="title-text" :span="10">{{ lanpack.testItem }}</el-col>
                  <el-col class="title-text" :span="7">{{ lanpack.delay }}</el-col>
                  <el-col class="title-text" :span="7">{{ lanpack.status }}</el-col>
                </el-row>
                <div class="result-content">
                  <el-row
                    class="result-item"
                    :class="index % 2 === 1 ? 'white-strip' : ''"
                    v-for="(urlCheck, index) in urlCheckList"
                    :key="index"
                  >
                    <el-col class="value-text" :span="10">{{ urlCheck.name }}</el-col>
                    <el-col
                      class="value-text"
                      :class="
                        urlCheck.statusKey === 'normal' || urlCheck.statusKey === 'fast'
                          ? ''
                          : getStatus(urlCheck.statusKey)['style']
                      "
                      :span="7"
                      >{{ urlCheck.delay }}</el-col
                    >
                    <el-col
                      class="value-text"
                      :class="getStatus(urlCheck.statusKey)['style']"
                      :span="7"
                      ><span>{{ getStatus(urlCheck.statusKey)['text'] }}</span
                      ><span :class="getStatus(urlCheck.statusKey)['icon']"></span
                    ></el-col>
                  </el-row>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane :label="lanpack.ImConnectTest" name="ImConnect">
              <div class="connect-check-container">
                <div class="info-container">
                  <div class="info-content">
                    <div class="info-title">{{ lanpack.xForwardInfo }}</div>
                    <div class="info-value">
                      <div class="value-title">{{ lanpack.ipTitle }}</div>
                      <div class="value-text">{{ xForwardIp }}</div>
                    </div>
                  </div>
                  <div class="info-content" style="margin-left: 6px">
                    <div class="info-title">{{ lanpack.dnsInfo }}</div>
                    <div class="info-value">
                      <div class="value-title">{{ lanpack.ipTitle }}</div>
                      <div class="value-text">{{ dnsIp }}</div>
                    </div>
                  </div>
                </div>
                <div class="url-container">
                  <div class="check-title">
                    {{ lanpack.httpConnect }}({{ httpConnectCount }}/{{
                      lanpack.httpsUrlList.length
                    }})
                  </div>
                  <div class="check-content">
                    <div
                      class="check-item"
                      v-for="(checkItem, index) in httpsCheckList"
                      :key="index"
                    >
                      <div
                        :class="
                          checkItem.result === '--'
                            ? 'check-text'
                            : getStatus(checkItem.result)['style']
                        "
                      >
                        {{ checkItem.url }}: {{ checkItem.result }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane :label="lanpack.ImSpeedTest" name="ImSpeed">
              <div class="speed-test-container">
                <div class="ip-content">
                  <div class="title-text">{{ lanpack.ipInfo }}</div>
                  <div class="value-content">
                    <div class="value-title">{{ lanpack.ipTitle }}</div>
                    <div class="value-text">{{ xForwardIp }}</div>
                  </div>
                </div>
                <div class="speed-content">
                  <div class="speed-title">{{ lanpack.speedInfo }}</div>
                  <div class="speed-result-content">
                    <div
                      class="speed-test-item"
                      v-for="(speedTest, index) in speedTestList"
                      :key="index"
                    >
                      {{ getDomain(speedTest.url) }}: {{ speedTest.result }}
                    </div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="right-content">
          <div class="hardware-content">
            <div class="hardware-title">
              <div class="title-text">{{ lanpack.networkCardInfo }}</div>
              <div class="split-line"></div>
              <div class="hardware-count">
                {{ lanpack.networkCardCount }}{{ getNetworkCard.length }}
              </div>
            </div>
            <div class="card-content">
              <el-tooltip v-for="(card, index) in getNetworkCard" :key="index">
                <div slot="content">
                  <p>{{ lanpack.adapterName }}{{ card.name }}</p>
                  <p>{{ lanpack.driverDesc }}{{ card.driverDescription }}</p>
                  <p>{{ lanpack.driverVer }}{{ card.driverVersionString }}</p>
                  <p>
                    {{ lanpack.interfaceType }}
                    {{ lanpack[card.interfaceType === 6 ? 'wired' : 'wireless'] }}
                  </p>
                  <p>{{ lanpack.conState }}{{ lanpack[getConState(card.mediaConnectState)] }}</p>
                  <p>{{ lanpack.adapterState }}{{ lanpack[getState(card.state)] }}</p>
                  <p>{{ lanpack.macAddress }}{{ card.mac }}</p>
                  <p>{{ lanpack.ipAddress }}{{ card.ip }}</p>
                  <el-button
                    v-if="card.driverUpdateFlag"
                    type="text"
                    style="color: #fff"
                    @click="updateDriver"
                    >{{ lanpack.driverUpdate }}</el-button
                  >
                </div>
                <div class="card-info">
                  <img
                    class="card-pic"
                    :src="require(`assets/pics/net_check/${getShowImg(card)}.png`)"
                  />
                  <div slot="reference" v-if="card.driverUpdateFlag" class="update-badge">!</div>
                </div>
              </el-tooltip>
            </div>
          </div>
          <div class="check-content">
            <div class="check-title">{{ lanpack.checkTitle }}</div>
            <img
              v-if="!errorFlag"
              class="check-load-pic"
              :src="require(`assets/pics/net_check/net_check.${checkingFlag ? 'gif' : 'png'}`)"
            />
            <div v-if="errorFlag" class="error-content">
              <div
                class="resolution-container"
                v-for="(resolution, index) in resolutionList"
                :key="index"
              >
                <div class="icon-content"></div>
                <div class="resolution-content">
                  <div class="resolution-value">{{ resolution.value }}</div>
                </div>
              </div>
            </div>
            <div class="normal-result-content" v-if="checkFinishFlag && !errorFlag">
              <div class="normal-result-text">{{ lanpack.normalResult }}</div>
            </div>
            <el-button
              v-if="!checkFinishFlag"
              type="primary"
              class="btn-check-start"
              @click="checkHandler()"
              >{{ checkBtnText }}</el-button
            >
            <div v-if="checkFinishFlag" class="operate-content">
              <el-popover v-model="reportFlag" trigger="hover">
                <div class="operate-dialog">
                  <div style="display: flex; justify-content: center; margin: 6px">
                    {{ lanpack.reportWarn }}
                  </div>
                  <div class="operate-dialog-content">
                    <el-button
                      type="default"
                      size="mini"
                      style="width: 76px; height: 28px"
                      @click="hideReport"
                      >{{ lanpack.cancel }}</el-button
                    >
                    <el-button
                      type="primary"
                      size="mini"
                      style="width: 76px; height: 28px"
                      :loading="reportingFlag"
                      @click="reportEventConfirm"
                      >{{ lanpack.confirm }}</el-button
                    >
                  </div>
                </div>
                <el-button
                  v-if="incNo === ''"
                  type="default"
                  style="width: 76px; height: 28px"
                  slot="reference"
                  @click="reportForRepair"
                  >{{ lanpack.clickForRepair }}</el-button
                >
                <el-button
                  v-else
                  type="default"
                  style="width: 76px; height: 28px"
                  slot="reference"
                  @click="reportForRepair"
                  >{{ lanpack.reportAgain }}</el-button
                >
              </el-popover>
              <el-button v-if="incNo !== ''" type="default" class="btn-operate" @click="copyInc"
                >{{ lanpack.shareInc }}
              </el-button>
              <el-button type="default" class="btn-operate" @click="showDialog">{{
                lanpack.detailLog
              }}</el-button>
              <el-button type="primary" class="btn-operate" @click="checkHandler()">{{
                checkBtnText
              }}</el-button>
            </div>
          </div>
        </div>
      </div>
      <el-dialog
        :visible.sync="detailDialogVisible"
        append-to-body
        top="9vh"
        width="750px"
        :close-on-click-modal="true"
        :close-on-press-escape="true"
        :show-close="true"
      >
        <el-scrollbar class="detail-container">
          <div class="detail-content">
            {{ totalDetails }}
          </div>
        </el-scrollbar>
        <div style="height: 20px"></div>
      </el-dialog>
    </div>
  </el-dialog>
</template>

<script>
import copy from 'copy-to-clipboard';
import socket from 'common/socket';
import tools from 'common/tools';
import { mapState, mapMutations, mapActions } from 'vuex';
import { ubtRegister, ubtSendTrace } from 'utils/ubt';

export default {
  data() {
    return {
      detailDialogVisible: false,
      totalDetails: '',
      urlCheckList: [],
      checkBtnText: '',
      checkingFlag: false,
      errorFlag: false,
      resolutionList: [],
      checkFinishFlag: false,
      urlCheckLogList: [],
      detailLogLength: 0,
      reportFlag: false,
      reportingFlag: false,
      currentTab: 'network',
      xForwardIp: '',
      dnsIp: '',
      httpConnectCount: 0,
      httpsCheckList: [],
      speedTestList: [],
      incNo: '',
      dialogHideFlag: false,
      pvId: '',
      checkCount: 0,
    };
  },
  props: {
    show: Boolean,
    lanpack: Object,
    lan: String,
    from: String,
    socketData: Object,
    networks: String,
  },
  computed: {
    ...mapState(['userInfo', 'deviceName', 'webDialogVisible', 'remedyIncNo']),
    getNetworkCard() {
      console.log('networks=======', this.networks);
      if (this.networks && this.networks != null) {
        return tools.sortByKey(JSON.parse(this.networks), 'interfaceType');
      }
      return [];
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.pvId = ubtRegister('Network Test');
        this.setPvId(this.pvId);
        console.log('display dialog===============');
        this.checkUrlHealth('print').then((res) => {
          console.log('print result   ', res);
          this.detailLogLength = res;
        });
        this.getUrlList();
        this.checkBtnText = this.lanpack.checkStart;
        this.getHttpsCheckList();
        this.getSpeedTestList();
        this.currentTab = 'network';
        this.dialogHideFlag = false;
        this.checkFinishFlag = false;
        if (localStorage.getItem('networkInc') && localStorage.getItem('networkInc') !== '') {
          this.incNo = localStorage.getItem('networkInc');
        }
      }
    },
  },
  methods: {
    ...mapMutations(['setWebDialogVisible', 'setSoftSearch', 'handleSoftSearch', 'setPvId']),
    ...mapActions(['saveLog', 'softApply', 'reportError']),
    getUrlList() {
      this.urlCheckList = this.lanpack.netCheckList.map((v) => ({
        name: v.name,
        delay: '-',
        status: this.lanpack.waitCheck,
        statusKey: 'undo',
        resolution: v.resolution,
      }));
    },
    getHttpsCheckList() {
      this.httpsCheckList = this.lanpack.httpsUrlList.map((v) => ({
        url: v,
        result: '--',
      }));
    },
    getSpeedTestList() {
      this.speedTestList = this.lanpack.speedTestList.map((v) => ({
        url: v,
        result: '--',
      }));
    },
    getStatus(status) {
      switch (status) {
        case 'normal':
          return {
            text: this.lanpack.normal,
            style: 'good-style',
            icon: 'el-icon-check',
          };
        case 'fast':
          return {
            text: this.lanpack.fast,
            style: 'good-style',
            icon: 'el-icon-check',
          };
        case 'success':
          return {
            text: this.lanpack.fast,
            style: 'good-style',
            icon: 'el-icon-check',
          };
        case 'slow':
          return {
            text: this.lanpack.slow,
            style: 'warn-style',
          };
        case 'error':
          return {
            text: this.lanpack.error,
            style: 'error-style',
            icon: 'el-icon-close',
          };
        case 'check':
          return { text: this.lanpack.testing, style: 'check-style' };
        default:
          return { text: this.lanpack.wait, style: 'wait-style' };
      }
    },
    getShowImg(adapter) {
      if (adapter.interfaceType === 6) {
        return adapter.mediaConnectState === 1 ? 'wired_on' : 'wired_off';
      }
      return adapter.mediaConnectState === 1 ? 'wifi_on' : 'wifi_off';
    },
    handleClose() {
      if (this.checkingFlag) {
        this.$message.warning(this.lanpack.checkingRemind);
        return;
      }
      if (this.from === 'HomeGrid') {
        this.setWebDialogVisible(false);
      } else {
        const internalCheck =
          this.urlCheckList[0].statusKey === 'fast' || this.urlCheckList[0].statusKey === 'normal';
        const externalCheck =
          this.urlCheckList[1].statusKey === 'fast' || this.urlCheckList[1].statusKey === 'normal';
        this.$parent.hideNetcheckDialog(internalCheck, externalCheck);
      }
      this.dialogHideFlag = true;
      this.checkingFlag = false;
      this.getUrlList();
      this.getHttpsCheckList();
      this.getSpeedTestList();
      this.currentTab = 'network';
      this.httpConnectCount = 0;
      this.xForwardIp = '';
      this.dnsIp = '';
      this.totalDetails = '';
      this.resolutionList = [];
      this.checkBtnText = this.lanpack.checkStart;
      this.errorFlag = false;
      this.checkFinishFlag = false;
    },
    getConState(state) {
      if (state === 1) return 'connected';
      if (state === 2) return 'disconnected';
      return 'unknown';
    },
    getState(state) {
      if (state === 1) return 'exist';
      if (state === 2) return 'enabled';
      return 'disabled';
    },
    async checkNet() {
      this.resolutionList = [];
      this.getUrlList();
      this.urlCheckLogList = [];
      for (let index = 0; index < this.lanpack.netCheckList.length; index += 1) {
        this.urlCheckList[index].status = this.lanpack.checking;
        this.urlCheckList[index].statusKey = 'check';
        const urlList = this.lanpack.netCheckList[index].checkList;
        const checkType = this.lanpack.netCheckList[index].condition;
        for (let idx = 0; idx < urlList.length; idx += 1) {
          if (this.dialogHideFlag) {
            return;
          }
          const url = urlList[idx];
          console.log(`${url} start`);
          let breakFlag = false;
          let statusKey = 'check';
          let delay = 0;
          // eslint-disable-next-line no-await-in-loop
          await this.checkUrlHealth(url).then((response) => {
            const data = JSON.parse(response);
            this.urlCheckLogList.push(data.message);
            if (data.status === 'error') {
              if (checkType === 'and') {
                breakFlag = true;
                statusKey = 'error';
                delay = 3000;
              }
            } else {
              if (data.delay < 1000) {
                statusKey = 'fast';
              } else if (data.delay >= 1000 && data.delay < 2000) {
                statusKey = 'normal';
              } else if (data.delay >= 2000 && data.delay < 3000) {
                statusKey = 'slow';
              } else {
                statusKey = 'error';
              }
              if (data.delay > delay) {
                delay = data.delay;
              }
              if (checkType === 'or') {
                breakFlag = true;
              }
            }
          });
          this.urlCheckList[index].statusKey = statusKey;
          this.urlCheckList[index].delay = `${delay}ms`;
          if (breakFlag) {
            break;
          }
        }
      }
      const errorList = this.urlCheckList.filter(
        // eslint-disable-next-line comma-dangle
        (v) => v.statusKey === 'slow' || v.statusKey === 'error'
      );

      if (errorList.length > 0) {
        this.errorFlag = true;
        if (errorList.length === this.urlCheckList.length) {
          this.resolutionList = [{ title: '', value: this.lanpack.allUrlErrorMsg }];
          return;
        }
        this.resolutionList = errorList.map((v) => ({
          title: v.name,
          value: v.resolution,
        }));
      }
    },
    checkUrlHealth(chkUrl) {
      return new Promise((resolve) => {
        const runData = { ...this.socketData };
        const userName = `${this.socketData.username}◎${chkUrl}`;
        runData.username = userName;
        console.log(runData);
        const socketDatas = tools.toUnicode(JSON.stringify(runData));
        const runCmd = `({"level":"user", "method":"tool_run", "data":"${socketDatas}"})`;
        socket.sendSocket(2, runCmd, (res) => {
          console.log('socket result', res);
          if (res.result === 'failed') {
            ubtSendTrace(245278, 'network_check', 'error', '', '', '', this.pvId, res.error);
            return;
          }
          const response = JSON.parse(res);
          if (response.data === 'Tool Exited') {
            resolve(response.info);
          }
        });
      });
    },
    showDialog() {
      this.totalDetails = '';
      this.checkUrlHealth('print').then(async (res) => {
        console.log('print result   ', res);
        this.detailLogLength = res;
        await this.getNetworkDetail(0);
        this.detailDialogVisible = true;
        ubtSendTrace(245278, 'network_check', 'click', 'log', '', '', this.pvId);
      });
    },
    reportForRepair() {
      if (this.reportingFlag) {
        return;
      }
      this.reportFlag = true;
    },
    hideReport() {
      if (this.reportingFlag) {
        return;
      }
      this.reportFlag = false;
    },
    async reportEventConfirm() {
      this.reportingFlag = true;
      if (this.totalDetails === '') {
        await this.getNetworkDetail(0);
      }
      const pcName = this.deviceName;
      let phone = '';
      const { empcode, displayName } = this.userInfo;
      const userBaseInfo = await this.softApply({ type: 'baseinfo' });
      if (userBaseInfo.status === 'success') {
        const userInfo = userBaseInfo.data;
        phone = userInfo.phone;
      }
      const reportResult = await this.reportError({
        type: 'network',
        lan: this.lan,
        empCode: empcode,
        displayName,
        phone,
        pcName,
        content: this.totalDetails,
        description: this.urlCheckLogList.join('\n'),
      });
      this.reportingFlag = false;
      this.reportFlag = false;
      switch (reportResult) {
        case 'success':
          this.$message.success(this.lanpack.reportSuccess);
          this.incNo = this.remedyIncNo;
          localStorage.setItem('networkInc', this.remedyIncNo);
          ubtSendTrace(245278, 'network_check', 'help', '', '', 'eventhelp', this.pvId);
          break;
        case 'limit':
          this.$message.warning({ message: this.lanpack.reportLimit, duration: 5000 });
          break;
        default:
          this.$message.warning({ message: this.lanpack.reportFail, duration: 5000 });
          break;
      }
      this.saveLog({
        title: this.from === 'HomeGrid' ? 'HomeGrid' : 'HomeCheck',
        target: 'ReportErrors',
        description: this.reportData,
        reserve1: `netinfo length = ${this.totalDetails.length}`,
      });
    },
    async getNetworkDetail(idx) {
      const maxSize = 50;
      const times = Math.floor(this.detailLogLength / maxSize);
      if (idx > times) {
        this.totalDetails += '------------------------------------------\r\n';
        this.totalDetails += `${this.lanpack.networkCardInfo}:\r\n`;
        this.getNetworkCard.forEach((el) => {
          this.totalDetails += `${this.lanpack.adapterName}: ${el.name}\r\n`;
          this.totalDetails += `${this.lanpack.driverDesc}: ${el.driverDescription}\r\n`;
          this.totalDetails += `${this.lanpack.driverVer}: ${el.driverVersionString}\r\n`;
          this.totalDetails += `${this.lanpack.interfaceType}: ${
            this.lanpack[el.interfaceType === 6 ? 'wired' : 'wireless']
          }\r\n`;
          this.totalDetails += `${this.lanpack.conState}: ${
            this.lanpack[this.getConState(el.mediaConnectState)]
          }\r\n`;
          this.totalDetails += `${this.lanpack.adapterState}: ${
            this.lanpack[this.getState(el.state)]
          }\r\n`;
          this.totalDetails += `${this.lanpack.macAddress}: ${el.mac}\r\n`;
          this.totalDetails += `${this.lanpack.ipAddress}: ${el.ip}\r\n`;
          this.totalDetails += '------------------------------------------\r\n';
        });
        this.addImLogs();
        return;
      }
      const start = idx * maxSize + 1;
      const end = idx === times ? this.detailLogLength : (idx + 1) * maxSize;
      await this.checkUrlHealth(`index|${start}|${end}`).then((res) => {
        this.totalDetails += res;
        // eslint-disable-next-line no-param-reassign
        this.getNetworkDetail((idx += 1));
      });
    },
    updateDriver() {
      this.handleClose();
      this.$router.push('/SoftwareInstall');
      setTimeout(() => {
        this.setSoftSearch('Intel AX 200 AX 201');
        this.handleSoftSearch('Intel AX 200 AX 201');
      }, 500);
    },
    testImSpeed() {
      this.getSpeedTestList();
      const fileWidth = 600;
      const fileHeight = 581;
      const fileSize = 1046937;
      for (let index = 0; index < this.speedTestList.length; index += 1) {
        this.speedTestList[index].result = '0 KB/s';
        const img = new Image();
        const startTimestamp = new Date();
        img.src = this.speedTestList[index].url;
        img.onload = () => {
          if (img.width === fileWidth && img.height === fileHeight) {
            const duration = (new Date() - startTimestamp) / 1000;
            const speed = fileSize / duration;
            this.speedTestList[index].result = `${parseInt((speed / 1024) * 100, 10) / 100} KB/s`;
            img.onload = () => {};
            img.onerror = () => {};
          } else {
            img.onerror();
          }
          img.onerror = () => {
            this.speedTestList[index].result = '0 KB/s';
            img.onload = () => {};
            img.onerror = () => {};
          };
        };
      }
    },
    getImConnectInfo() {
      return new Promise((resolve) => {
        const runData = { ...this.socketData };
        const userName = `${this.socketData.username}◎im+dns`;
        runData.username = userName;
        const socketDatas = tools.toUnicode(JSON.stringify(runData));
        const runCmd = `({"level":"user", "method":"tool_run", "data":"${socketDatas}"})`;
        socket.sendSocket(2, runCmd, (res) => {
          const response = JSON.parse(res);
          console.log('socket result', res);
          if (response.result === 'failed') {
            return;
          }
          if (response.data === 'Tool Exited') {
            const imData = JSON.parse(response.info);
            resolve(imData);
          }
        });
      });
    },
    async checkHttpsUrlHealth() {
      this.getHttpsCheckList();
      this.httpConnectCount = 0;
      for (let index = 0; index < this.httpsCheckList.length; index += 1) {
        if (this.dialogHideFlag) {
          return;
        }
        const { url } = this.httpsCheckList[index];
        this.httpsCheckList[index].result = '--';
        // eslint-disable-next-line no-await-in-loop
        await this.checkUrlHealth(url).then((res) => {
          const data = JSON.parse(res);
          this.httpConnectCount = index + 1;
          this.httpsCheckList[index].result = data.status.toLowerCase();
        });
      }
    },
    getDomain(url) {
      const arr = url.match(/:\/\/([^\\/]*)/);
      return (arr && arr[1]) || 'unknown';
    },
    copyInc() {
      copy(this.incNo);
      this.$message.success(this.lanpack.copySuccess);
    },
    async checkHandler() {
      if (this.checkingFlag) {
        return;
      }
      ubtSendTrace(245278, 'network_check', 'click', 'log', '', '', this.pvId);
      if (this.checkCount > 1) {
        ubtSendTrace(245278, 'network_check', 'click', 'recheck', '', '', this.pvId);
      }
      this.checkFinishFlag = false;
      this.checkBtnText = this.lanpack.checking;
      this.checkingFlag = true;
      this.currentTab = 'network';
      await this.checkNet();
      this.currentTab = 'ImConnect';
      await this.getImConnectInfo().then((imData) => {
        this.xForwardIp = imData.data.ip;
        this.dnsIp = imData.data.localdns;
      });
      await this.checkHttpsUrlHealth();
      this.currentTab = 'ImSpeed';
      await this.getImConnectInfo().then((imData) => {
        this.xForwardIp = imData.data.ip;
        this.dnsIp = imData.data.localdns;
      });
      this.testImSpeed();
      this.checkingFlag = false;
      this.checkBtnText = this.lanpack.recheck;
      this.checkFinishFlag = true;
      this.checkCount += 1;
    },
    addImLogs() {
      let logData = '------------------------------------------\r\nIM: \n';
      logData += `X-FORWARDED IP: ${this.xForwardIp}\r\n`;
      logData += `DNS IP: ${this.dnsIp}\r\n`;
      this.httpsCheckList.forEach((el) => {
        logData += `${el.url}: ${el.result}\r\n`;
      });
      this.speedTestList.forEach((el) => {
        logData += `${el.url}: ${el.result}\r\n`;
      });
      this.totalDetails += logData;
    },
    selectTab(tab) {
      ubtSendTrace(245278, 'network_check', 'click_tag', tab.name, '', '', this.pvId);
    },
  },
};
</script>

<style lang="scss" scoped>
.main-container {
  margin-top: -20px;
  padding-bottom: 20px;
  .header-container {
    height: 50px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    background: linear-gradient(90deg, rgb(0, 183, 255) 0%, rgb(0, 128, 255) 100%);
    .header-tip {
      text-align: center;
      line-height: 50px;
      color: #ffffff;
      font-size: 20px;
    }
    .dialog-close {
      border-radius: 12px;
      border: 1px solid #fff;
      text-align: center;
      position: absolute;
      right: 16px;
      top: 12px;
      color: #fff;
      height: 24px;
      width: 24px;
      line-height: 24px;
      cursor: pointer;
    }
  }
  .body-container {
    display: flex;
    margin: 16px 18px;

    .left-content {
      width: 354px;
      height: 410px;
      background: #f2f7ff;
      border-radius: 8px 8px 8px 8px;
      margin-right: 18px;
      display: flex;
      flex-direction: column;
      position: relative;

      .title-content {
        color: #333333;
        font-size: 12px;
        font-weight: normal;
        letter-spacing: 0px;
        margin: 12px 16px;
        box-shadow: none !important;
      }
      .result-container {
        height: 346px;
        display: flex;
        flex-direction: column;
        .result-title {
          display: flex;
          background: #ffffff;

          .title-text {
            height: 32px;
            display: flex;
            color: #1466de;
            font-size: 14px;
            font-weight: 500;
            letter-spacing: 0px;
            align-items: center;
            justify-content: center;
          }
        }

        .result-content {
          // max-height: 278px;
          overflow-y: auto;
          margin-bottom: 15px;
          .result-item {
            height: 32px;
            border-radius: 4px;
            display: flex;
            .value-text {
              display: flex;
              font-size: 12px;
              font-weight: normal;
              letter-spacing: 0px;
              align-items: center;
              justify-content: center;
            }
          }
        }
      }

      .connect-check-container {
        display: flex;
        flex-direction: column;
        height: 346px;

        .info-container {
          display: flex;

          .info-content {
            width: 158px;
            height: 54px;
            background: #ffffff;
            border-radius: 4px;
            display: flex;
            flex-direction: column;

            .info-title {
              display: flex;
              line-height: 17px;
              color: #1466de;
              font-size: 12px;
              font-weight: normal;
              letter-spacing: 0px;
              margin: 8px 0 4px 8px;
            }

            .info-value {
              display: flex;
              margin-left: 8px;

              .value-title {
                line-height: 17px;
                color: #333333;
                font-size: 12px;
                font-weight: normal;
                letter-spacing: 0px;
              }

              .value-text {
                line-height: 17px;
                color: #666666;
                font-size: 12px;
                font-weight: normal;
                letter-spacing: 0px;
              }
            }
          }
        }

        .url-container {
          width: 322px;
          height: 272px;
          background: #ffffff;
          border-radius: 4px;
          display: flex;
          flex-direction: column;
          margin: 8px 0 14px 0;

          .check-title {
            display: flex;
            line-height: 17px;
            color: #1466de;
            font-size: 12px;
            font-weight: normal;
            letter-spacing: 0px;
            margin: 8px;
          }

          .check-content {
            height: 238px;
            display: flex;
            flex-direction: column;
            overflow-y: auto;
            margin: 8px;

            .check-item {
              display: flex;

              .check-text {
                line-height: 16px;
                color: #666666;
                font-size: 12px;
                font-weight: normal;
                letter-spacing: 0px;
              }
            }
          }
        }
      }

      .speed-test-container {
        display: flex;
        flex-direction: column;
        height: 346px;

        .ip-content {
          width: 322px;
          height: 54px;
          background: #ffffff;
          border-radius: 4px;
          display: flex;
          flex-direction: column;

          .title-text {
            display: flex;
            line-height: 17px;
            color: #1466de;
            font-size: 12px;
            font-weight: normal;
            letter-spacing: 0px;
            margin: 8px 0 0 8px;
          }

          .value-content {
            display: flex;
            margin: 4px 0 8px 8px;

            .value-title {
              display: flex;
              line-height: 17px;
              color: #333333;
              font-size: 12px;
              font-weight: normal;
              letter-spacing: 0px;
            }
            .value-text {
              display: flex;
              line-height: 17px;
              color: #666666;
              font-size: 12px;
              font-weight: normal;
              letter-spacing: 0px;
            }
          }
        }

        .speed-content {
          width: 322px;
          height: 270px;
          background: #ffffff;
          border-radius: 4px;
          display: flex;
          flex-direction: column;
          margin-top: 8px;

          .speed-title {
            display: flex;
            line-height: 17px;
            color: #1466de;
            font-size: 12px;
            font-weight: normal;
            letter-spacing: 0px;
            margin: 8px;
          }

          .speed-result-content {
            height: 238px;
            display: flex;
            flex-direction: column;
            margin: 0 0 12px 8px;
            overflow-y: auto;

            .speed-test-item {
              line-height: 16px;
              color: #666666;
              font-size: 12px;
              font-weight: normal;
              letter-spacing: 0px;
            }
          }
        }
      }
    }

    .right-content {
      width: 392px;
      border-radius: 8px;
      display: flex;
      flex-direction: column;

      .hardware-content {
        width: 392px;
        height: 94px;
        background: #f2f7ff;
        border-radius: 8px;
        display: flex;
        flex-direction: column;

        .hardware-title {
          display: flex;
          align-items: center;
          height: 17px;
          margin: 12px 16px 13px 16px;

          .title-text {
            line-height: 17px;
            color: rgb(51, 51, 51);
            font-size: 12px;
            font-weight: normal;
            letter-spacing: 0px;
          }
          .split-line {
            width: 1px;
            height: 8px;
            background: rgb(220, 233, 252);
            border-radius: 1px 1px 1px 1px;
            margin: 0 8px;
          }

          .hardware-count {
            display: flex;
            line-height: 14px;
            color: rgb(153, 153, 153);
            font-size: 10px;
            font-weight: normal;
            letter-spacing: 0px;
          }
        }
        .card-content {
          display: flex;

          .card-info {
            width: 40px;
            height: 34px;
            background: rgb(255, 255, 255);
            border-radius: 4px 4px 4px 4px;
            margin-left: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;

            .card-pic {
              width: 24px;
              height: 24px;
            }

            .update-badge {
              position: absolute;
              top: -10px;
              right: -6px;
              background-color: #f56c6c;
              border-radius: 10px;
              color: #fff;
              display: inline-block;
              font-size: 12px;
              width: 6px;
              height: 18px;
              line-height: 18px;
              padding: 0 6px;
              text-align: center;
              white-space: nowrap;
              border: 1px solid #fff;
              cursor: pointer;
            }
          }
        }
      }

      .check-content {
        margin-top: 16px;
        width: 392px;
        height: 300px;
        background: #f2f7ff;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        position: relative;

        .check-title {
          display: flex;
          height: 17px;
          color: rgb(51, 51, 51);
          font-size: 12px;
          font-weight: normal;
          letter-spacing: 0px;
          align-items: center;
          margin: 12px 16px;
        }

        .check-load-pic {
          position: absolute;
          top: 37px;
          left: 61px;
          width: 270px;
          height: 150px;
        }

        .error-content {
          display: flex;
          flex-direction: column;
          max-height: 194px;
          overflow-y: auto;
          margin: 0 10px;

          .resolution-container {
            display: flex;
            background: rgb(255, 255, 255);
            border-radius: 4px;
            margin-bottom: 8px;
            position: relative;

            .icon-content {
              width: 8px;
              height: 8px;
              background: radial-gradient(
                ellipse 100% 0% at 63.14% 29.28%,
                rgb(0, 221, 178) 0%,
                rgb(0, 184, 122) 100%
              );
              position: absolute;
              top: 13px;
              left: 16px;
            }

            .resolution-content {
              display: flex;
              flex-direction: column;
              margin: 8px 8px 8px 32px;

              .resolution-title {
                display: flex;
                line-height: 18px;
                color: rgb(51, 51, 51);
                font-size: 12px;
                font-weight: normal;
                letter-spacing: 0px;
                margin-bottom: 4px;
              }
              .resolution-value {
                display: flex;
                line-height: 18px;
                color: rgb(243, 69, 0);
                font-size: 12px;
                font-weight: normal;
                letter-spacing: 0px;
                margin-bottom: 16px;
              }
            }
          }
        }

        .normal-result-content {
          width: 392px;
          height: 17px;
          position: absolute;
          bottom: 75px;
          // border: 1px solid #000;
          display: flex;
          justify-content: center;

          .normal-result-text {
            line-height: 16px;
            color: #00b87a;
            font-size: 12px;
            font-weight: normal;
            letter-spacing: 0px;
          }
        }

        .btn-check-start {
          width: 76px;
          height: 28px;
          position: absolute;
          left: 158px;
          bottom: 16px;
        }

        .btn-check-restart {
          width: 76px;
          height: 28px;
          position: absolute;
          right: 74px;
          bottom: 16px;
        }

        .operate-content {
          position: absolute;
          left: 0px;
          bottom: 16px;
          width: 392px;
          height: 28px;
          display: flex;
          justify-content: center;

          .operate-dialog {
            display: flex;
            flex-direction: column;

            .operate-dialog-title {
              display: flex;
              font-size: 12px;
              font-weight: normal;
              letter-spacing: 0px;
              line-height: 17px;
              text-align: center;
              justify-content: center;
            }
          }

          .btn-operate {
            width: 76px;
            height: 28px;
            margin-left: 8px;
          }
        }
      }
    }
  }
}

.good-style {
  color: #00b87a;
}
.warn-style {
  color: #ff8f00;
}
.error-style {
  color: #f34500;
}
.check-style {
  color: #666666;
}
.wait-style {
  color: #cccccc;
}
.detail-container {
  height: 465px;
  margin: 20px 20px 0 20px;
  white-space: pre-line;
  font-size: 12px;
}
::v-deep .el-dialog {
  border-radius: 8px;
}
.white-strip {
  background: rgba(255, 255, 255, 0.7);
}
</style>
